
import { Component, Input } from '@angular/core';
import {
    NavController,
    NavParams
} from 'ionic-angular';
import { RodeoEventRun } from '../../../../model/rodeoEventRun';
import { Rodeo } from '../../../../model/rodeo';
import { RodeoEvent } from '../../../../model/rodeoEvent';
import { LeaderGenerator } from '../../../../lib/leaderGenerator';
import { ReportsService } from '../../../../services/reports.service';
import { RunDisplayHelper } from '../../../../lib/run-display-helper';
import { Membership } from '../../../../model/membership';
import { Account } from '../../../../model/account';
import { TeamService } from '../../../../services/team.service';
import { Team } from 'model/team';
import { PayoutConfig } from 'model/payoutConfig';

@Component({
    selector: 'page-points-report',
    templateUrl: 'report-points.html'

})
export class PointsReport {
    @Input('rodeo') rodeo: Rodeo;

    allAround: any = { displayName: 'All Around', id: -5, configuration: { runs: { decimalPlaces: 2 } } };
    allAroundEligible: any = { displayName: 'All Around Eligible', id: -4, configuration: { runs: { decimalPlaces: 2 } } };
    teamSelection: any = { displayName: 'Teams', id: -3, configuration: { runs: { decimalPlaces: 2 } } };
    mensTeams: any = { displayName: "Men's Teams", id: -2, configuration: { runs: { decimalPlaces: 2 } } };
    womensTeams: any = { displayName: "Women's Teams", id: -1, configuration: { runs: { decimalPlaces: 2 } } };
    selectedRodeoEvent: RodeoEvent;
    teams: Team[];
    payoutConfigs: PayoutConfig[] = [];

    documentTitle: any;

    popoverActive: boolean;
    dataLoaded: boolean;
    printing: boolean;

    totalPoints: number;

    pointLeaderMap: Map<number, any> = new Map<number, any>();
    accountPointSummary: Map<number, number> = new Map<number, any>();
    accountPointDetails: Map<number, RodeoEventRun[]> = new Map<number, RodeoEventRun[]>();
    accountIdMap: Map<number, Account> = new Map<number, Account>();
    accountIdTeamMap: Map<number, Team> = new Map<number, Team>();

    selectedMembership: Membership;
    memberships: any[];

    runDisplayHelper: RunDisplayHelper = RunDisplayHelper.instance();

    constructor(private nav: NavController, navParams: NavParams, private reportService: ReportsService, private teamService: TeamService) {
        if (!this.rodeo)
            this.rodeo = navParams.get('rodeo');

        this.selectedRodeoEvent = navParams.get('selectedRodeoEvent');
        this.selectedMembership = navParams.get('selectedMembership');

        this.printing = navParams.get('print');

        if (this.printing)
            this.load();
    }

    load() {
        this.memberships = [{ name: 'None' }];

        if (this.rodeo.sanctionedOrganizations.length > 0)
            this.memberships.push(...this.rodeo.sanctionedOrganizations.flatMap(x => x.memberships));

        if (!this.selectedMembership)
            this.selectedMembership = this.memberships[0];

        this.updateRodeoEvent();

        this.mapAllPoints();

        this.documentTitle = this.rodeo.name + " - " + 'Points';
        this.dataLoaded = true;
    }

    async mapAllPoints() {
        this.pointLeaderMap = new Map<number, any[]>();
        this.accountPointSummary = new Map<number, number>();
        var accountAllAroundEligibleCount = new Map<number, number>();
        var accountAllAroundQualifiedCount = new Map<number, number>();

        this.teams = await this.teamService.getTeams(this.rodeo.id);
        this.teams.forEach((team) => {
            team.contestants.forEach((contestant) => {
                this.accountIdTeamMap.set(contestant.accountId, team);
            })
        });

        this.rodeo.rodeoEvents.flatMap(x => x.schedules).flatMap(x => x.runs).forEach(run => {
            this.accountIdMap.set(run.contestantOneId, run.contestantOne);

            if (run.contestantTwoId)
                this.accountIdMap.set(run.contestantTwoId, run.contestantTwo);
        });

        this.rodeo.rodeoEvents.forEach((rodeoEvent) => {
            var payoutConfig = {} as PayoutConfig;

            console.log("Assessing points for ", rodeoEvent.displayName);

            rodeoEvent.winners.forEach((winner) => {
                if (payoutConfig && winner.payoutConfigId != payoutConfig.id) {
                    var schedule = rodeoEvent.schedules.filter(x => x.id == winner.scheduleId)[0];

                    payoutConfig = this.rodeo.payoutConfigs.filter(x => x.id == payoutConfig.id)[0];

                    let leaders = LeaderGenerator.instance().getLeaders(this.rodeo, payoutConfig, 10, true, true, rodeoEvent.fallBackToPlace);

                    leaders.forEach(group => {
                        group.runs.forEach((run, index) => {
                            if ((!group.mode.isAggregate && !group.mode.isAverage) || run.displaySuccessfulRuns == 0) {
                                if (run.noTime || run.turnedOut) {
                                    run.points = 0;
                                    return;
                                }
                            }

                            run.points = Math.max(0, 60 + (-10 * index)) * 1;

                            var currentIndex = index;
                            while (currentIndex > 0) {
                                if (group.mode.isAggregate || group.mode.isAverage) {
                                    if (!rodeoEvent.configuration.runs.scoreValue) {
                                        if (run.totalTime == group.runs[currentIndex - 1].totalTime) {
                                            run.points += Number(group.runs[currentIndex - 1].points) * 1;
                                        } else {
                                            break;
                                        }
                                    } else {
                                        if (run.totalScore == group.runs[currentIndex - 1].totalScore) {
                                            run.points += Number(group.runs[currentIndex - 1].points) * 1;
                                        } else {
                                            break;
                                        }
                                    }
                                } else {
                                    if (!rodeoEvent.configuration.runs.scoreValue) {
                                        if (run.time == group.runs[currentIndex - 1].time) {
                                            run.points += Number(group.runs[currentIndex - 1].points) * 1;
                                        } else {
                                            break;
                                        }
                                    } else {
                                        if (run.score == group.runs[currentIndex - 1].score) {
                                            run.points += Number(group.runs[currentIndex - 1].points) * 1;
                                        } else {
                                            break;
                                        }
                                    }
                                }

                                currentIndex--;
                            }

                            if (index > 0) {
                                var newPoints = run.points / (index - currentIndex + 1);

                                while (currentIndex <= index) {
                                    group.runs[currentIndex].points = newPoints;
                                    currentIndex++;
                                }
                            }

                            if (run.points == 0)
                                return;
                        });

                        group.runs.forEach(x => {
                            if (x.points == 0)
                                return;

                            x.points = Number(x.points).toFixed(2);

                            this.totalPoints += Number(x.points) * 1;
                        });

                        if (!this.pointLeaderMap.has(rodeoEvent.id))
                            this.pointLeaderMap.set(rodeoEvent.id, { groups: [] });

                        this.pointLeaderMap.get(rodeoEvent.id).groups.push(group);
                    });
                }
            });

            if (this.pointLeaderMap.has(rodeoEvent.id)) {
                this.pointLeaderMap.get(rodeoEvent.id).groups.sort((a, b) => {
                    if ((a.mode.aggregate || a.mode.average) && (!b.mode.aggregate || !b.mode.average))
                        return 1;
                    else if ((!a.mode.aggregate || !a.mode.average) && (b.mode.aggregate || b.mode.average))
                        return -1;


                    if (a.mode.round < b.mode.round)
                        return -1;
                    else
                        return 1;
                })

                var currentEventPointSummary = new Map<number, number>();

                this.pointLeaderMap.get(rodeoEvent.id).groups.forEach((group) => {
                    group.runs.forEach((run, runIndex) => {
                        if (!currentEventPointSummary.has(run.contestantOne.id))
                            currentEventPointSummary.set(run.contestantOne.id, 0);

                        currentEventPointSummary.set(run.contestantOne.id, currentEventPointSummary.get(run.contestantOne.id) + run.points * 1);

                        if (!this.accountPointDetails.has(run.contestantOne.id))
                            this.accountPointDetails.set(run.contestantOneId, []);

                        if (run.points > 0) {
                            run.place = runIndex + 1;
                            run.name = rodeoEvent.displayName + ' - ' + group.name;
                            this.accountPointDetails.get(run.contestantOneId).push(run);
                        }

                        if (run.contestantTwoId) {
                            if (!currentEventPointSummary.has(run.contestantTwo.id))
                                currentEventPointSummary.set(run.contestantTwo.id, 0);

                            currentEventPointSummary.set(run.contestantTwo.id, currentEventPointSummary.get(run.contestantTwo.id) + run.points * 1);

                            if (!this.accountPointDetails.has(run.contestantTwo.id))
                                this.accountPointDetails.set(run.contestantTwoId, []);

                            if (run.points > 0) {
                                this.accountPointDetails.get(run.contestantTwoId).push(run);
                            }
                        }
                    });
                });

                this.pointLeaderMap.get(rodeoEvent.id).groups.forEach((group) => {
                    group.runs.forEach((run) => {
                        if (group.mode.round == rodeoEvent.rounds || (!rodeoEvent.shortGo && rodeoEvent.rounds - group.mode.round == 1) && !group.mode.aggregate && !group.mode.average) {
                            if (!accountAllAroundEligibleCount.has(run.contestantOne.id))
                                accountAllAroundEligibleCount.set(run.contestantOne.id, 0);

                            accountAllAroundEligibleCount.set(run.contestantOne.id, accountAllAroundEligibleCount.get(run.contestantOne.id) * 1 + 1);
                            //console.log(`${run.contestantOne.firstName} ${run.contestantOne.lastName} made short. Currently made ${accountAllAroundEligibleCount.get(run.contestantOne.id)} shorts.`);

                            if (currentEventPointSummary.get(run.contestantOne.id) > 0) {
                                if (!accountAllAroundQualifiedCount.has(run.contestantOne.id))
                                    accountAllAroundQualifiedCount.set(run.contestantOne.id, 0);

                                accountAllAroundQualifiedCount.set(run.contestantOne.id, accountAllAroundQualifiedCount.get(run.contestantOne.id) * 1 + 1);
                                //console.log(`${run.contestantOne.firstName} ${run.contestantOne.lastName} made qualification. Currently made ${accountAllAroundQualifiedCount.get(run.contestantOne.id)} qualifications.`);
                            }

                            if (run.contestantTwo) {
                                if (!accountAllAroundEligibleCount.has(run.contestantTwo.id))
                                    accountAllAroundEligibleCount.set(run.contestantTwo.id, 0);

                                accountAllAroundEligibleCount.set(run.contestantTwo.id, accountAllAroundEligibleCount.get(run.contestantTwo.id) * 1 + 1);
                                //console.log(`${run.contestantTwo.firstName} ${run.contestantTwo.lastName} made short. Currently made ${accountAllAroundEligibleCount.get(run.contestantTwo.id)} shorts.`);

                                if (currentEventPointSummary.get(run.contestantTwo.id) > 0) {
                                    if (!accountAllAroundQualifiedCount.has(run.contestantTwo.id))
                                        accountAllAroundQualifiedCount.set(run.contestantTwo.id, 0);

                                    accountAllAroundQualifiedCount.set(run.contestantTwo.id, accountAllAroundQualifiedCount.get(run.contestantTwo.id) * 1 + 1);
                                    //console.log(`${run.contestantTwo.firstName} ${run.contestantTwo.lastName} made qualification. Currently made ${accountAllAroundQualifiedCount.get(run.contestantTwo.id)} qualifications.`);
                                }
                            }
                        }
                    });
                });

                var eventSummaryGroup = { name: "Summary", mode: { aggregate: false, average: false }, runs: [], startTime: 0 };

                currentEventPointSummary.forEach((value, key) => {
                    if (!this.accountPointSummary.has(key))
                        this.accountPointSummary.set(key, 0);

                    const teamName = this.accountIdTeamMap.has(key) ? this.accountIdTeamMap.get(key).name : 'None';
                    eventSummaryGroup.runs.push({ contestantOne: this.accountIdMap.get(key), contestantOneId: key, secondDisplayValue: teamName, points: +value.toFixed(2), time: '', score: '' })
                    this.accountPointSummary.set(key, this.accountPointSummary.get(key) * 1 + value * 1);
                });

                eventSummaryGroup.runs.sort((a, b) => {
                    if (a.points > b.points)
                        return -1;
                    else if (a.points < b.points)
                        return 1;

                    return 0;
                })

                this.pointLeaderMap.get(rodeoEvent.id).groups.push(eventSummaryGroup);
            }
        });

        var mensGroup = { name: 'All Around Men', mode: { aggregate: false, average: false }, runs: [] };
        var womensGroup = { name: 'All Around Women', mode: { aggregate: false, average: false }, runs: [] };

        accountAllAroundQualifiedCount.forEach((count, account) => {
            if (count > 1) {
                if (this.accountIdMap.get(account).male)
                    mensGroup.runs.push({ contestantOne: this.accountIdMap.get(account), contestantOneId: account, points: this.accountPointSummary.get(account) });
                else
                    womensGroup.runs.push({ contestantOne: this.accountIdMap.get(account), contestantOneId: account, points: this.accountPointSummary.get(account) });
            }
        });

        mensGroup.runs.sort((a, b) => {
            if (a.points > b.points)
                return -1;
            else if (a.points < b.points)
                return 1;

            return 0;
        })

        womensGroup.runs.sort((a, b) => {
            if (a.points > b.points)
                return -1;
            else if (a.points < b.points)
                return 1;

            return 0;
        })

        this.pointLeaderMap.set(-5, { groups: [mensGroup, womensGroup] });

        var mensGroup = { name: 'All Around Eligible Men', mode: { aggregate: false, average: false }, runs: [] };
        var womensGroup = { name: 'All Around Eligible Women', mode: { aggregate: false, average: false }, runs: [] };

        accountAllAroundEligibleCount.forEach((count, account) => {
            if (count > 1) {
                if (this.accountIdMap.get(account).male)
                    mensGroup.runs.push({ contestantOne: this.accountIdMap.get(account), contestantOneId: account, points: this.accountPointSummary.get(account) });
                else
                    womensGroup.runs.push({ contestantOne: this.accountIdMap.get(account), contestantOneId: account, points: this.accountPointSummary.get(account) });
            }
        });

        mensGroup.runs.sort((a, b) => {
            if (a.points > b.points)
                return -1;
            else if (a.points < b.points)
                return 1;

            return 0;
        })

        womensGroup.runs.sort((a, b) => {
            if (a.points > b.points)
                return -1;
            else if (a.points < b.points)
                return 1;

            return 0;
        })

        this.pointLeaderMap.set(-4, { groups: [mensGroup, womensGroup] });

        this.mapTeams();
    }

    async mapTeams() {
        var accountIdMapping = new Map<number, Account>();
        this.rodeo.rodeoEvents.flatMap(x => x.schedules).flatMap(x => x.runs).forEach(run => {
            accountIdMapping.set(run.contestantOneId, run.contestantOne);

            if (run.contestantTwoId)
                accountIdMapping.set(run.contestantTwoId, run.contestantTwo);
        });

        this.pointLeaderMap.set(-3, { groups: [] });
        this.teams.forEach((team) => {
            var leaderGroup = { name: team.name, mode: { aggregate: false, average: false }, runs: [], startTime: 0 };

            leaderGroup.startTime = 0;
            team.contestants.forEach((contestant) => {
                if (this.accountPointSummary.has(contestant.accountId)) {
                    leaderGroup.startTime += this.accountPointSummary.get(contestant.accountId) * 1;
                    leaderGroup.runs.push({ contestantOne: accountIdMapping.get(contestant.accountId), contestantOneId: contestant.accountId, points: this.accountPointSummary.get(contestant.accountId).toFixed(2), runs: this.accountPointDetails.get(contestant.accountId) })
                }
            })

            leaderGroup.runs.sort((a, b) => {
                if (a.points > b.points)
                    return -1;
                else if (a.points < b.points)
                    return 1;

                return 0;
            })

            this.pointLeaderMap.get(-3).groups.push(leaderGroup);
        });

        this.pointLeaderMap.get(-3).groups.sort((a, b) => {
            if (a.startTime > b.startTime)
                return -1;
            else if (a.startTime < b.startTime)
                return 1;
        });

        var leaderGroup = { name: "Team Summary", mode: { aggregate: false, average: false }, runs: [], startTime: 0 };
        this.pointLeaderMap.get(-3).groups.forEach(group => {
            leaderGroup.runs.push({ contestantOne: { firstName: group.name, lastName: '', memberships: [] }, contestantOneId: -1, points: group.startTime.toFixed(2) })
        });

        this.pointLeaderMap.get(-3).groups.unshift(leaderGroup);

        this.pointLeaderMap.set(-2, { groups: [] });
        this.teams.filter(x => x.maleOnly).forEach((team) => {
            var leaderGroup = { name: team.name, mode: { aggregate: false, average: false }, runs: [], startTime: 0 };

            leaderGroup.startTime = 0;
            team.contestants.forEach((contestant) => {
                if (this.accountPointSummary.has(contestant.accountId)) {
                    leaderGroup.startTime += this.accountPointSummary.get(contestant.accountId) * 1;
                    leaderGroup.runs.push({ contestantOne: accountIdMapping.get(contestant.accountId), contestantOneId: contestant.accountId, points: this.accountPointSummary.get(contestant.accountId).toFixed(2), runs: this.accountPointDetails.get(contestant.accountId) })
                }
            })

            leaderGroup.runs.sort((a, b) => {
                if (a.points > b.points)
                    return -1;
                else if (a.points < b.points)
                    return 1;

                return 0;
            })

            this.pointLeaderMap.get(-2).groups.push(leaderGroup);
        });

        this.pointLeaderMap.get(-2).groups.sort((a, b) => {
            if (a.startTime > b.startTime)
                return -1;
            else if (a.startTime < b.startTime)
                return 1;
        });

        var leaderGroup = { name: "Team Summary", mode: { aggregate: false, average: false }, runs: [], startTime: 0 };
        this.pointLeaderMap.get(-2).groups.forEach(group => {
            leaderGroup.runs.push({ contestantOne: { firstName: group.name, lastName: '', memberships: [] }, contestantOneId: -1, points: group.startTime.toFixed(2) })
        });

        this.pointLeaderMap.get(-2).groups.unshift(leaderGroup);

        this.pointLeaderMap.set(-1, { groups: [] });
        this.teams.filter(x => x.femaleOnly).forEach((team) => {
            var leaderGroup = { name: team.name, mode: { aggregate: false, average: false }, runs: [], startTime: 0 };

            leaderGroup.startTime = 0;
            team.contestants.forEach((contestant) => {
                if (this.accountPointSummary.has(contestant.accountId)) {
                    leaderGroup.startTime += this.accountPointSummary.get(contestant.accountId) * 1;
                    leaderGroup.runs.push({ contestantOne: accountIdMapping.get(contestant.accountId), contestantOneId: contestant.accountId, points: this.accountPointSummary.get(contestant.accountId).toFixed(2), runs: this.accountPointDetails.get(contestant.accountId) })
                }
            })

            leaderGroup.runs.sort((a, b) => {
                if (a.points > b.points)
                    return -1;
                else if (a.points < b.points)
                    return 1;

                return 0;
            })

            this.pointLeaderMap.get(-1).groups.push(leaderGroup);
        });

        this.pointLeaderMap.get(-1).groups.sort((a, b) => {
            if (a.startTime > b.startTime)
                return -1;
            else if (a.startTime < b.startTime)
                return 1;
        });

        var leaderGroup = { name: "Team Summary", mode: { aggregate: false, average: false }, runs: [], startTime: 0 };
        this.pointLeaderMap.get(-1).groups.forEach(group => {
            leaderGroup.runs.push({ contestantOne: { firstName: group.name, lastName: '', memberships: [] }, contestantOneId: -1, points: group.startTime.toFixed(2) })
        });

        this.pointLeaderMap.get(-1).groups.unshift(leaderGroup);
    }

    updateRodeoEvent() {
        if (!this.selectedRodeoEvent)
            this.selectedRodeoEvent = this.rodeo.rodeoEvents[0];
    }

    matchRodeoEvents(a, b) {
        return a.id == b.id;
    }

    matchSchedules(a, b) {
        return !a.id && !b.id || a.id == b.id;
    }

    matchSelections(a, b) {
        return a.name == b.name;
    }

    matchStrings(a, b) {
        return a == b;
    }

    ionViewDidEnter() {
        setTimeout(() => {
            window.document.title = this.documentTitle;
            window.print();
            this.nav.pop();
        }, 0);
    }

    isRoughStock(rodeoEvent: RodeoEvent) {
        if (rodeoEvent.eventType === 'BullRiding' || rodeoEvent.eventType === 'SaddleBroncRiding' || rodeoEvent.eventType === 'RanchBroncRiding' || rodeoEvent.eventType === 'BarebackRiding')
            return true;
        else
            return false;
    }

    getFirstDisplay(run: RodeoEventRun) {
        return ` ${run.contestantOne.firstName} ${run.contestantOne.lastName}` + (run.contestantOne.memberships.filter(x => x.membershipId == this.selectedMembership.id)[0] != null && run.contestantOne.memberships.filter(x => x.membershipId == this.selectedMembership.id)[0].id != null ? ' #' + run.contestantOne.memberships.filter(x => x.membershipId == this.selectedMembership.id)[0].id : '');
    }

    getSecondDisplay(rodeoEvent: RodeoEvent, run: RodeoEventRun) {
        var secondDisplayValue = '';

        var valuesToDisplay = rodeoEvent.configuration.runs.slotTwoFieldName.split('+');

        valuesToDisplay.forEach(value => {
            var propertiesInValue = value.split('.');

            var objectWithValue: any;
            objectWithValue = run;

            var lastProperty = '';
            propertiesInValue.forEach(property => {
                if (!objectWithValue) {
                    objectWithValue = lastProperty == 'livestock' ? 'Livestock 1' : 'Horse 1';
                    return;
                }

                objectWithValue = objectWithValue[property];
                lastProperty = property;
            });

            secondDisplayValue += objectWithValue + ' ';
        });

        return secondDisplayValue.substring(0, secondDisplayValue.length - 1);
    }

    getSecondLabel(rodeoEvent: RodeoEvent) {
        return rodeoEvent.configuration.runs.slotTwoLabel;
    }

    print() {
        if (this.popoverActive)
            return;

        this.popoverActive = true;

        this.nav.push(PointsReport, {
            rodeo: this.rodeo,
            print: true,
            selectedRodeoEvent: this.selectedRodeoEvent,
            selectedMembership: this.selectedMembership
        }).then(() => { this.popoverActive = false; });
    }

    download() {
        const report = [];
        this.pointLeaderMap.get(this.selectedRodeoEvent.id).groups.forEach(group => {
            let i = 1;
            group.runs.forEach(run => {
                const runObj = {
                    Category: group.name,
                    Place: i++,
                    Run: run.number,
                } as any;

                if (run.contestantTwo) {
                    runObj.Header = `${run.contestantOne.firstName} ${run.contestantOne.lastName}`;
                    runObj.Heeler = `${run.contestantTwo.firstName} ${run.contestantTwo.lastName}`;

                    if (run.horseTwo) {
                        runObj.HorseTwo = run.horseTwo != null ? run.horseTwo.name : 'Horse 2';
                    }
                } else {
                    runObj.Name = `${run.contestantOne.firstName} ${run.contestantOne.lastName}`;
                }

                if (this.selectedMembership)
                    runObj.MembershipId = run.contestantOne.memberships.filter(x => x.membershipId == this.selectedMembership.id)[0] != null && run.contestantOne.memberships.filter(x => x.membershipId == this.selectedMembership.id)[0].id != null ? ' #' + run.contestantOne.memberships.filter(x => x.membershipId == this.selectedMembership.id)[0].id : '';

                if (this.selectedRodeoEvent.eventType == 'BarrelRacing') {
                    runObj.Horse = run.horseOne != null ? run.horseOne.name : 'Horse 1';
                    runObj.Time = this.runDisplayHelper.getRunValue(this.selectedRodeoEvent, run, group.mode.aggregate || group.mode.average, true, group.mode);
                } else if (this.isRoughStock(this.selectedRodeoEvent)) {
                    runObj.Stock = run.livestock != null ? run.livestock.brand + ' ' + run.livestock.name : 'Livestock 1';
                    runObj.Score = this.runDisplayHelper.getRunValue(this.selectedRodeoEvent, run, group.mode.aggregate || group.mode.average, true, group.mode);
                } else {
                    runObj.Stock = run.livestock != null ? run.livestock.brand + ' ' + run.livestock.name : 'Livestock 1';
                    runObj.Time = this.runDisplayHelper.getRunValue(this.selectedRodeoEvent, run, group.mode.aggregate || group.mode.average, true, group.mode);
                }

                runObj.Points = run.points;

                report.push(runObj);
            });
        });

        this.reportService.exportToCsv(report, `${this.rodeo.name} - ${this.selectedRodeoEvent.displayName} - Points`);
    }


}


// WEBPACK FOOTER //
// ./src/pages/staff/rodeo/reports/report-points.ts